var newStyles = [{ elementType: 'geometry', stylers: [{ color: '#e39dc8' }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] }, { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] }, { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] }, { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#000000' }] }, { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] }, { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }, { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] }, { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#000000' }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] }, { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }, { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] }, { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#ffffff' }] }, { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }];

var map;
var markers = [];
var selectedMarker;
var mapSliderState = true;
var myStatus;

if ($('.section-locator').length) {
  var markers_json = document.getElementById('my_markers').innerHTML;
  var corners_json = document.getElementById('my_corners').innerHTML;
  var checkCorners = document.getElementById("field-corners");
  var checkTiendas = document.getElementById("field-tiendas");

  google.maps.event.addDomListener(window, 'load', initializeMain);

  var bounds = new google.maps.LatLngBounds();
};

if ($('#map-marker-icon').length) {
  var customIconMarker = $('#map-marker-icon').attr('src');

  if (customIconMarker.includes('no-image')) {
    customIconMarker = 'https://cdn.shopify.com/s/files/1/0063/4142/7289/files/store_position_icon_e89d1b71-741c-4854-ac15-c9b1e99e0173.png?6141689267859931680';
  }

  var activeIcon = {
    url: customIconMarker
  };
};

$('#store-search .list-checkboxes input').on('change', function () {
  initializeMain();
  filterStores();
  $('.stores').removeClass('filterStores');
  if ($(window).width() < 767) {
    scrollToElement($('.section-locator .section__map'));
  };
});

function initializeMain() {
  var mapElement = document.getElementById('map');
  var latCenter = mapElement.getAttribute('data-lat');
  var lngCenter = mapElement.getAttribute('data-lng');
  var zoom = parseInt(mapElement.getAttribute('data-zoom'));

  var mapOptions = {
    zoom: zoom,

    mapTypeId: google.maps.MapTypeId.ROADMAP,
    center: new google.maps.LatLng(latCenter, lngCenter)
  };

  if ($(mapElement).length) {
    var filePath = mapElement.getAttribute('data-json');

    map = new google.maps.Map(mapElement, mapOptions);

    var results = JSON.parse(markers_json);

    if (checkCorners.checked == true) {
      results = JSON.parse(corners_json);
    } else {
      results = JSON.parse(markers_json);
    }

    setLocations(results);
  }

  function setLocations(locations) {
    markers = locations.features;

    for (var i = 0; i < markers.length; i++) {
      var lat = markers[i].properties.latitud,
          lng = markers[i].properties.longitud,
          icon = activeIcon;
      var markerOject = storeMarkers[i];
      var storeMarkerId;

      if (typeof markerOject !== 'undefined') {
        storeMarkerId = storeMarkers[i].id;
      } else {
        storeMarkerId = 'empty';
      }

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        icon: icon,
        animation: google.maps.Animation.DROP,
        customInfo: storeMarkerId
      });

      fitBounds(map, marker);
      var bounds = map.getBounds();

      markers[i].marker = marker;

      var markerLat;
      var markerLng;

      marker.addListener('click', function () {
        if (selectedMarker) {
          selectedMarker.setIcon(activeIcon);
        }

        this.setIcon(activeIcon);
        this.setAnimation(google.maps.Animation.DROP);
        selectedMarker = this;
        map.panTo(this.getPosition());
        map.setZoom(16);

        markerLat = this.position.lat();
        markerLng = this.position.lng();

        $('.store').removeClass('active');
        var $activeMarker;

        $('.marker-link').each(function () {
          $activeMarker = $(this);

          if (markerLat.toString().includes($activeMarker.data('lat'))) {
            $activeMarker.closest('.store').addClass('active');

            $('.section-locator .section__body').stop().animate({
              scrollTop: $activeMarker.closest('.store').position().top
            }, 900);
          };
        });
      });
    }
  }

  var geocoder = new google.maps.Geocoder();

  document.getElementById('store-search-submit').addEventListener('click', function (event) {
    
    event.preventDefault();
    initializeMain();
    geocodeAddress(geocoder, map);
  });
}

function geocodeAddress(geocoder, resultsMap) {
  var valueToSearch;
  var cpToSearch;
  var address = 'Spain ' + document.getElementById('address').value;

  geocoder.geocode({ address: address }, function (results, status) {
    if (status == 'ZERO_RESULTS') {
      $('.stores').removeClass('filterStores');
      $('.store').removeClass('filtered');
    };

    if (status === 'OK') {
      var searchValue = document.getElementById('address');
      valueToSearch = searchValue.value.toString().toLowerCase();
      if (valueToSearch.isInteger){
        cpToSearch = valueToSearch.substring(0,2);
      }

      $('.store').removeClass('filtered');

      $('.store .store__title a').each(function () {
        var locationTitle = $(this).closest('.store').find('.store__subtitle').text().toString().toLowerCase();
        var $this = $(this);

        if (!valueToSearch.includes('spain')) {
          $('.stores').addClass('filterStores');
          if (locationTitle.includes(valueToSearch)) {
            $this.trigger('click');
            $this.closest('.store').addClass('filtered');
          }
        }
      });

      resultsMap.setCenter(results[0].geometry.location);

      map.setZoom(10);
    } else {
      /*alert('Geocode was not successful for the following reason: ' + status);*/
    }
  });

  return myStatus;
}

externalMapLinks($('.marker-link'));

function externalMapLinks($link) {
  $link.on('click', function (event) {
    event.preventDefault();

    var $this = $(this);
    var data = $this.data();
    var $parent = $this.closest('li');

    setActiveMarker(data);

    if ($(window).width() < 767) {
      scrollToElement($('.section-locator .section__map'));
    };
  });
}

function setActiveMarker(data) {
  var markerLat = data.lat;
  var markerLng = data.lng;

  for (var i = 0; i < markers.length; i++) {
    if (markers[i].properties.latitud.includes(markerLat)) {
      var currentMarker = markers[i].marker;

      map.panTo(currentMarker.getPosition());
      map.setZoom(16);
    }
  }
}

function filterStores() {
  if (checkCorners.checked == true) {
    $('.type--store').hide();
    $('.type--corner').show();
  } else {
    $('.type--store').show();
    $('.type--corner').hide();
  }
}

$(window).on('load', function () {
  if ($('.section-locator').length) {
    filterStores();
  };
});

function scrollToElement($target) {
  $('html, body').stop().animate({
    scrollTop: $target.offset().top - 150
  }, 900);
}

function fitBounds(map, marker) {
  bounds.extend(marker.position);
  map.fitBounds(bounds);
}